import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { Tooltip, Icon } from 'antd';
import { valuation_titles } from '../statics';
import Table from '../../../../../components/table/Table';
import { getVal } from '../../../../../shared/helpers';
import { checkValuationExpired } from '../../../utils/checkValuationExpired';

const tooltipLeadType = (
    <span>
        Lead type was updated:<br/>
        - check Lead History tab<br/>
        - manual revaluation required
    </span>
);

const style = {
    expired: {
        textDecoration: 'line-through'
    }
};

export default connect(state => ({
    lead_division_id: getVal(state.Leads, 'Lead_profile.Lead_general.ref_lead_source'),
    valuations: state.Leads.Lead_profile.Lead_valuations.valuations,
    isLeadTypeUpdate: state.Leads.Lead_profile.leadHistory.isLeadTypeUpdate,
    userGroups: getVal(state, 'App.App_content.user.groups'),
}), null)(class Valuations extends Component {
    state = {
        part_valuations: 3,
    };

    showAllValuations = () => this.setState({ part_valuations: this.props.valuations.length });

    hideAllValuations = () => this.setState({ part_valuations: 3 });


    render() {
        const is_user_admin_or_super_user = this.props.userGroups.some(group => group._id === '5d7f6909bdee754d2fc96667' || group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024');

        let titles = valuation_titles;
        if (!is_user_admin_or_super_user) {
            if (!this.props.valuations.length) {
                titles = valuation_titles.filter(e => e.title !== 'Retail');
            }
        }
        const { valuations, lead_division_id, isLeadTypeUpdate } = this.props;

        return (
            <div className="profile__information valuations">
                <div className="profile__data valuation">
                    <h3>
                        Valuations{' '}
                        {isLeadTypeUpdate && <Tooltip title={tooltipLeadType}><Icon type='warning' style={{color: "red", fontSize: 14}}/></Tooltip>}
                        {valuations.length > 3 && this.state.part_valuations === 3
                            ? <span className="select_manually" onClick={this.showAllValuations}>Show all valuations</span>
                            : this.state.part_valuations > 3
                                ? <span className="select_manually" onClick={this.hideAllValuations}>Hide all valuations</span> : null}
                    </h3>
                    <div className="tableWrapper">
                        <div className="profile__contact">
                            {!valuations.length
                                ? <span style={{ fontStyle: 'italic', width: '100%' }}>There is no Valuations for this bike</span>
                                : (
                                    <Table>
                                        <thead>
                                            <tr>{titles.map((title, index) => <th key={index} className="tableHeader">{title}</th>)}</tr>
                                        </thead>
                                        <tbody>
                                            {valuations.slice(0, this.state.part_valuations).map((item) => {

                                                const { hasExpired } = checkValuationExpired({ divisionId: lead_division_id._id, lastValuationDate: item.created_date });

                                                return (
                                                    <tr key={item._id} style={hasExpired ? style.expired : style.active}>
                                                        <td><Moment format="D MMM YYYY">{item.created_date}</Moment></td>
                                                        <td style={{ width: '57%' }}>
                                                            £
                                                            {item.valuation}
                                                            {' '}
                                                            {`(${item.valuation_by.person.first_name.substring(0, 1)}${item.valuation_by.person.last_name.substring(0, 1)})`}
                                                        </td>
                                                        {is_user_admin_or_super_user && (
                                                            <td>
                                                                £
                                                                {item.retail_price}
                                                            </td>
                                                        )}
                                                        <td>{item.division} {hasExpired && <>EXPIRED</>}</td>
                                                    </tr>)
                                            })}
                                        </tbody>
                                    </Table>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/Valuations.js